<template>
  <div class="home">
    <div class="header">
      <a class="logo" href="https://bio.lvwzhen.com/">
        <div class="text">
          Clubhouse
          <br />Bio Maker
        </div>
      </a>
      <div class="author">
       <a href="https://lvwzhen.com/" target="_blank">
          <div id="flip"> 
            <div>
              <div>Indie Hacker</div>
            </div>

            <div>
              <div>I'm</div>
            </div>
            
             <div>
              <div>By lvwzhen</div>
            </div>
          </div>
        </a>
      </div>
    </div>

    <h2>Who are you?</h2>
    <div class="biography-style" v-if="Mobile">
      <div class="style-list">
        <div class="items">
          <div class="style-item">
            <input
              type="radio"
              name="bioStyle"
              v-model="bioStyle"
              id="label01"
              value="label01"
              @change="handle"
            />
            <label for="label01">
              <em>👽</em>Big Brother
            </label>
          </div>

          <div class="style-item">
            <input
              type="radio"
              name="bioStyle"
              v-model="bioStyle"
              id="label02"
              value="label02"
              @change="handle"
            />
            <label for="label02">
              <em>👩🏻‍💼</em>Professional
            </label>
          </div>

          <!-- <div class="style-item">
            <input
              type="radio"
              name="bioStyle"
              v-model="bioStyle"
              id="label03"
              value="label03"
              @change="handle"
            />
            <label for="label03">
              <em>🎷</em>Musician
            </label>
          </div> -->

          <div class="style-item">
            <input
              type="radio"
              name="bioStyle"
              v-model="bioStyle"
              id="label04"
              value="label04"
              @change="handle"
            />
            <label for="label04">
              <em>💃</em>Artiste
            </label>
          </div>
        </div>

        <div class="items">
          <!-- <div class="style-item">
            <input
              type="radio"
              name="bioStyle"
              v-model="bioStyle"
              id="label05"
              value="label05"
              @change="handle"
            />
            <label for="label05">
              <em>📺</em>KOL
            </label>
          </div> -->

          <div class="style-item">
            <input
              type="radio"
              name="bioStyle"
              v-model="bioStyle"
              id="label07"
              value="label07"
              @change="handle"
            />
            <label for="label07">
              <em>👨🏻‍💻</em>Indie Hacker
            </label>
          </div>

          <div class="style-item">
            <input
              type="radio"
              name="bioStyle"
              v-model="bioStyle"
              id="label06"
              value="label06"
              @change="handle"
            />
            <label for="label06">
              <em>👨🏽‍🎓</em>Student
            </label>
          </div>

          <div class="style-item">
            <input
              type="radio"
              name="bioStyle"
              v-model="bioStyle"
              id="label08"
              value="label08"
              @change="handle"
            />
            <label for="label08">
              <em>😎</em>Popular Emoji
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="biography-style" v-else>
      <div class="style-list">
        <div class="style-item">
          <input
            type="radio"
            name="bioStyle"
            v-model="bioStyle"
            id="label01"
            value="label01"
            @change="handle"
          />
          <label for="label01">
            <em>👽</em>Big Brother
          </label>
        </div>

        <div class="style-item">
          <input
            type="radio"
            name="bioStyle"
            v-model="bioStyle"
            id="label02"
            value="label02"
            @change="handle"
          />
          <label for="label02">
            <em>👩🏻‍💼</em>Professional
          </label>
        </div>

        <!-- <div class="style-item">
          <input
            type="radio"
            name="bioStyle"
            v-model="bioStyle"
            id="label03"
            value="label03"
            @change="handle"
          />
          <label for="label03">
            <em>🎷</em>Musician
          </label>
        </div> -->

        <div class="style-item">
          <input
            type="radio"
            name="bioStyle"
            v-model="bioStyle"
            id="label07"
            value="label07"
            @change="handle"
          />
          <label for="label07">
            <em>👨🏻‍💻</em>Indie Hacker
          </label>
        </div>


        <div class="style-item">
          <input
            type="radio"
            name="bioStyle"
            v-model="bioStyle"
            id="label04"
            value="label04"
            @change="handle"
          />
          <label for="label04">
            <em>💃</em>Artiste
          </label>
        </div>

        <!-- <div class="style-item">
          <input
            type="radio"
            name="bioStyle"
            v-model="bioStyle"
            id="label05"
            value="label05"
            @change="handle"
          />
          <label for="label05">
            <em>📺</em>KOL
          </label>
        </div> -->

        
        <div class="style-item">
          <input
            type="radio"
            name="bioStyle"
            v-model="bioStyle"
            id="label06"
            value="label06"
            @change="handle"
          />
          <label for="label06">
            <em>👨🏽‍🎓</em>Student
          </label>
        </div>

        <div class="style-item">
          <input
            type="radio"
            name="bioStyle"
            v-model="bioStyle"
            id="label08"
            value="label08"
            @change="handle"
          />
          <label for="label08">
            <em>😎</em>Popular Emoji
          </label>
        </div>
      </div>
    </div>

    <div class="bio-box">
      <div class="bio-textarea">
        <textarea name id cols="30" rows="10" v-model="bioContent">😈  I'm CEO, Bitch.</textarea>
      </div>
    </div>

    <div class="copy">
      <button class="copy-btn" @click="doCopy" :disabled="disabled">✂️ Copy it!</button>
    </div>

    <div class="footer">
      <div class="cell">
        <a href="https://twitter.com/lvwzhen" target="_black">☎️ Need more, Call me.</a>
      </div>
      <div class="cell">
        <a href="https://avatar.lvwzhen.com/" target="_black">🤖 Generate CH avatar now!</a>
      </div>
    </div>

    <div class="sponsored">
      Sponsored by <a href="https://www.zhihu.com/column/wusebest" target="_blank"><img src="../assets/img/wusebest.png" alt="wusebest.com"></a>
    </div>

    <!-- producthunt -->
    <div class="producthunt">
      <a href="https://www.producthunt.com/posts/clubhouse-bio-maker?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-clubhouse-bio-maker" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=283807&theme=light" alt="Clubhouse Bio Maker - Quickly generate your clubhouse Bio! | Product Hunt" style="width: 250px; height: 54px;" width="250" height="54" /></a>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Vue from "vue";
import "vant/lib/toast/style";
Vue.use(Toast);
export default {
  components: {},
  data() {
    return {
      bioStyle: "label01",
      bioContent: "😈  I'm CEO, Bitch.",
      disabled: false,
      Mobile: false,
    };
  },
  methods: {
    doCopy: function () {
      this.$copyText(this.bioContent).then(
        function () {
          Toast("Copied! Paste it in your Bio.");
        },
        function () {
          Toast("Can not copy!");
        }
      );
      this.disabled = true;
      setTimeout(() => {
        this.disabled = false;
      }, 1000);
    },
    handle: function () {
      if (this.bioStyle == "label01") {
        this.bioContent = "😈  I'm CEO, Bitch.";
      } else if (this.bioStyle == "label02") {
        this.bioContent =
          "🧑🏼‍💻 Product Manager @Google \n EX-Tesla / EX-Apple \n \n  I love making friends with different people 🤟 \n ❤️ Listen more, Share more. \n  \n Created： \n 🎙  Interesting Tech Podcast \n 📙  The Code For Continued Growth \n  \n Born in 🇮🇳 / Living in 🇺🇸\n 🐦 StephenWatts\n 📷 StephenWatts42\n 📮 Stephen@gmailx.com";
      } else if (this.bioStyle == "label03") {
        this.bioContent = "";
      } else if (this.bioStyle == "label04") {
        this.bioContent = "⚡️⚡️⚡️\nHosts / Actors / YouTuber / Director\n\n🏃🏾‍♂️Running in movies since 1995.\n\n📺 Sunday Night Live\n📽 The Bourne Revenge / The Last knight / John Reacher\n🏆 Academy Award for Best Director\n\nSNS @TomDamon\nYoutube 12M / Instagram 10M / Twitter 6.5M ";
      } else if (this.bioStyle == "label05") {
        this.bioContent = "";
      } else if (this.bioStyle == "label06") {
        this.bioContent =
          "📍 Tokyo ✈️  Boston \n🙋🏻‍♀️ Japanese / English\n\n🎓 Economics @U-Tokyo\n🎓 Machine Learning @Harvard\n\nLove to do something fun 🧗🏻‍♀️ 🎸 ☕️\nInterning @Amazon\n\nYou can find me on\n📷 IG：helloyukino\n🌎 FB：helloyukino\n👻 SNAP：yukino\n";
      } else if (this.bioStyle == "label07") {
        this.bioContent = "😎 I'm a Freelancer / Indie Hacker / YouTuber  / Traveler.\n\n🧑🏼‍💻 Worked at Facebook.\n✈️ Traveling around the world, 1,000,000km flying distance.\n🏖 Living in Bali Indonesia at this moment.\n🪂 Learning to skydive.\n\nWhat i created?\n☑️ Daily To-do App\n🔗 RemoteAwesome.com\n📺  Design&Code channel\n\nHow to find me?\n🐦 TW @DavidFinch\n📸 IG @DavidFinchLife\n📮 davidfinch@live.co";
      } else if (this.bioStyle == "label08") {
        this.bioContent =
          "Location：\n📍📌✈️\n🏠🕌🗻\n🗼🏯🗽\n\nIdentity：\n🧑🏼‍💻🧑🏻‍🎓👩‍🏫\n🧑🏽‍🎨💃🏃🏾‍♂️\n🎓💼👘\n\nSkill：\n🎨🎬🎙\n📹💻🛠\n🥋🥘🎩\n\nAwesome：\n😎😇😂\n🤔🤟😉\n🌟👽🕶\n\nActivity：\n⚽️🤿🪂\n🏄‍♂️🎮🎸\n🧗‍♂️🎹🥊\n\nSocial：\n🐦🌎📷\n👀👻☎️\n📺📮📠\n";
      }
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  mounted() {
    if (this.isMobile()) {
      this.Mobile = true;
    } else {
      this.Mobile = false;
    }
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@500;600;700&display=swap");
body {
  font-family: "Quicksand", "Helvetica Neue", Roboto, Arial, sans-serif;
}
.van-uploader__preview-image {
  width: 240px;
  height: 240px;
}
</style>